/**
 * Manual 3.2 Initial Lodging Round.
 *
 * Frontend AI auto-pick: always pick own faction. Mirrors the backend
 * Fossa default and keeps simulations from getting stuck in GAME_SETUP.
 *
 * 2026-05-14: Initial Lodging Round goes seat-by-seat (see
 * engine/round_choices/initial_lodging_round.py). All six seats
 * start in GAME_SETUP, but only the one marked as game.current_player
 * is allowed to send an InitialLodging response — every other seat's
 * click comes back as "Initial Lodging response from non-active seat
 * N." The frontend AI used to fire all Feai seats in parallel on
 * launch; gate the execute on current_player so we wait our turn.
 */
export default function artificialInitialLodging(gamePlayerController, aiPackage) {
    const gamePlayer = gamePlayerController.gamePlayerData;
    // Read from game.gameData directly; controller.gameData is only
    // synced inside gamePlayerEventListener, which runs *after* the
    // game-event listener that fires this AI on a current_player
    // advance — so the controller's copy is one tick stale here.
    const gameData = gamePlayerController.game && gamePlayerController.game.gameData;
    let factionId = gamePlayer.faction;
    // Never emit a null faction. A seat can reach this handler with faction
    // still null — post-CC_LOBBY seats defer faction assignment to the Manual
    // §3 ceremony, and a GAME_SETUP <-> CHOOSE_FACTION status desync can drive
    // this handler while the engine is already at CHOOSE_FACTION expecting a
    // pick. initialLodgingChoice(null) trips the engine's NO_PREASSIGNED_FACTION
    // reject (choose_faction.choose_faction_response) and the clockwise ceremony
    // spins on that seat until a reload re-syncs (G118, 2026-07-12). Mirror
    // AIChooseFaction's null handling: pick the first unclaimed faction so the
    // click always carries a legal faction and the seat always advances
    // (HSH_STYLE §AI always-act — a silent/illegal emit is the only wrong move).
    if (factionId === null || factionId === undefined) {
        const claimed = new Set();
        const seats = (gameData && gameData.gameplayer_set) || [];
        for (const seat of seats) {
            if (!seat) continue;
            if (seat.id === gamePlayer.id) continue;
            if (seat.faction) claimed.add(seat.faction);
        }
        for (let candidate = 1; candidate <= 6; candidate += 1) {
            if (!claimed.has(candidate)) {
                factionId = candidate;
                break;
            }
        }
    }
    const isActiveSeat = gameData && gameData.current_player === gamePlayer.id;
    aiPackage.success = true;
    aiPackage.addToMessage(`Initial Lodging - faction ${factionId}`);
    aiPackage.addProvenance(
        'Which faction matches my Hotel?',
        `Faction ${factionId}`,
        'Own faction; first unclaimed if unassigned.');
    if (!isActiveSeat) {
        aiPackage.addToMessage(
            'Waiting for my turn in the Initial Lodging Round.');
        return;
    }
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.initialLodgingChoice(factionId);
    }
}
